import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import logo from '../../../../assets/img/manvar-logo.png'
import { justifyText } from "common/PDFUtils/pdfUtils";


export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const { paymentCalculation, porcentajeToFloat, convertToFloat } = Helpers

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode } = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const { setShowForm } = globalStates

        const { FormRequestGlobal: { onResetForm } } = Forms

        onResetForm()

        setShowForm(false)
    }

    const onSubmitFormQuotation = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormRequestGlobal: { formState } } = Forms

        const { modalOpeningMode } = globalStates

        const { fetchAllQuotations: { executeFetchAllQuotations } } = FetchData

        if (formState.tipo_cuota === '') {
            alertMessage({
                title: 'FAIL',
                message: 'Debe seleccionar un Tipo de cuota'
            })
            return
        }

        if (formState.interes === 0) {
            alertMessage({
                title: 'FAIL',
                message: 'Debe seleccionar un Tipo de interes'
            })
            return
        }

        let _data = []

        if (formState.tipo_cuota === 'CUOTA NIVELADA') {
        
            _data = {
                nombre_cliente: formState.nombre_cliente,
                nombre_usuario_cliente: user.username,
                tipo_cuota: formState.tipo_cuota,
                interes: (formState.interes / 100),
                interes_total: porcentajeToFloat(formState.interes_total),
                enganche: porcentajeToFloat(formState.enganche),
                plazo: formState.plazo,
                plazo_anios: formState.plazo_anios,

                monto_venta: formState.clean_monto_venta,
                monto_enganche: formState.clean_monto_enganche,
                gps: formState.clean_gps,
                seguro: formState.clean_seguro,
                otros: formState.clean_otros,
                cuota_niv: formState.clean_cuota_niv,
                saldo_financiar: formState.clean_saldo_financiar,
                total_cuota: formState.clean_total_cuota,

                descripcion: formState.descripcion
            }
        }else{
            _data = {
                nombre_cliente: formState.nombre_cliente,
                nombre_usuario_cliente: user.username,
                tipo_cuota: formState.tipo_cuota,
                interes: (formState.interes / 100),
                interes_total: porcentajeToFloat(formState.interes_total),
                enganche: 0,
                plazo: formState.plazo,
                plazo_anios: formState.plazo_anios,

                monto_venta: formState.clean_monto_venta,
                monto_enganche: 0,
                gps: formState.clean_gps,
                seguro: formState.clean_seguro,
                otros: formState.clean_otros,
                cuota_niv: 0,
                saldo_financiar: formState.clean_saldo_financiar,
                total_cuota: formState.clean_total_cuota,

                descripcion: formState.descripcion
            }
        }

        await marvarApi.post(`/herr-cotizador-credito/registrar-cotizacion-credito`, _data)
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    executeFetchAllQuotations()
                    handleClickHideForm()
                }

            }).catch(error => { console.log('API ERROR: ', error) })

    }


    const handleButtonDisable = (idcotizacion) => {
        const { fetchAllQuotations: { executeFetchAllQuotations } } = FetchData

        const _body = {
            idcotizacion: idcotizacion,
            user: user.username
        }

        Swal.fire({
            title: '¿Desea eliminar esta cotizacion?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Elimnar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await marvarApi.post(`/herr-cotizador-credito/delete`, _body)
                    .then(({ data }) => {

                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllQuotations()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            }
        })
    }

    const handleChangeTypeLoan = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChange } } = Forms
        const { clean_monto_venta, clean_monto_enganche, plazo, gps, seguro, otros, tipo_cuota } = formState

        const { name, value } = event.target


        onInputChange(event)
        const interes_float = (parseFloat(value) / 100).toFixed(4)

        const interes_total_data = parseFloat((value * 12).toFixed(2));
        // console.log(monto_venta, monto_enganche, interes_float, plazo);

        const cuota_niv = paymentCalculation(clean_monto_venta, clean_monto_enganche, value, plazo)

        // console.log(cuota_niv);

        const cuota_total = parseFloat(cuota_niv) + parseFloat(gps) + parseFloat(seguro) + parseFloat(otros);
        const cuota_total_libre = parseFloat(clean_monto_venta * interes_float) + parseFloat(gps) + parseFloat(seguro) + parseFloat(otros);

        if (tipo_cuota === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                interes_total: `${interes_total_data} %`,
                cuota_niv: cuota_niv,
                total_cuota: cuota_total.toFixed(2)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                interes_total: `${interes_total_data} %`,
                // cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,
            }))
        }

    }

    const handleChangeDownPayment = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms
        const {
            clean_monto_venta,
            clean_gps,
            clean_seguro,
            clean_otros,
            interes,
            plazo,
        } = formState

        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        let enganche = ((clean_value / clean_monto_venta) * 100).toFixed(2);
        enganche = isNaN(enganche) ? 0 : enganche

        const saldo_financiar = (clean_monto_venta - clean_value).toFixed(2);
        const cuota_niv = paymentCalculation(clean_monto_venta, clean_value, interes, plazo)
        const cuota_total = (parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros))

        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        setFormState(prevState => ({
            ...prevState,
            // [ name ]: value,
            enganche: `${enganche} %`,
            saldo_financiar: numberFormatter.format(saldo_financiar),
            clean_saldo_financiar: saldo_financiar,
            cuota_niv: numberFormatter.format(cuota_niv),
            clean_cuota_niv: cuota_niv,
            total_cuota: numberFormatter.format(cuota_total),
            clean_total_cuota: cuota_total,
        }))
    }

    const handleChangeMount = (event) => {


        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms
        const {
            clean_monto_enganche,
            clean_gps,
            clean_seguro,
            clean_otros,
            plazo,
            interes,
            tipo_cuota
        } = formState
        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        let enganche = ((clean_monto_enganche / clean_value) * 100).toFixed(2);
        enganche = isNaN(enganche) ? 0 : enganche
        const saldo_financiar = (clean_value - clean_monto_enganche).toFixed(2);
        const cuota_niv = paymentCalculation(clean_value, clean_monto_enganche, interes, plazo)
        const cuota_total = (parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros))
        const cuota_total_libre = parseFloat(clean_value * (interes / 100)) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);
        // console.log(cuota_niv, cuota_total, enganche, saldo_financiar );

        if (tipo_cuota === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                // [ name ]: value,
                enganche: `${enganche} %`,
                saldo_financiar: numberFormatter.format(saldo_financiar),
                clean_saldo_financiar: saldo_financiar,
                cuota_niv: numberFormatter.format(cuota_niv),
                clean_cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total),
                clean_total_cuota: cuota_total,
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                // [ name ]: value,
                enganche: `${enganche} %`,
                saldo_financiar: numberFormatter.format(clean_value),
                clean_saldo_financiar: clean_value,
                // cuota_niv: numberFormatter.format(cuota_niv),
                // clean_cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,
            }))

        }

    }

    const handleChangeTypeCredit = (event) => {


        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onSelectSearchChange } } = Forms
        const {
            clean_monto_venta,
            clean_monto_enganche,
            clean_gps,
            clean_seguro,
            clean_otros,
            plazo,
            interes,
            tipo_cuota
        } = formState

        onSelectSearchChange(event)

        const { value } = event.target

        console.log(value);


        let enganche = ((clean_monto_enganche / clean_monto_venta) * 100).toFixed(2);
        enganche = isNaN(enganche) ? 0 : enganche
        const saldo_financiar = (clean_monto_venta - clean_monto_enganche).toFixed(2);
        const cuota_niv = paymentCalculation(clean_monto_venta, clean_monto_enganche, interes, plazo)
        const cuota_total = (parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros))
        const cuota_total_libre = parseFloat(clean_monto_venta * (interes / 100)) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);
        // console.log(cuota_niv, cuota_total, enganche, saldo_financiar );

        if (value === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                // [ name ]: value,
                enganche: `${enganche} %`,
                saldo_financiar: numberFormatter.format(saldo_financiar),
                clean_saldo_financiar: saldo_financiar,
                cuota_niv: numberFormatter.format(cuota_niv),
                clean_cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total),
                clean_total_cuota: cuota_total,
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                // [ name ]: value,
                enganche: `${enganche} %`,
                saldo_financiar: numberFormatter.format(clean_monto_venta),
                clean_saldo_financiar: clean_monto_venta,
                // cuota_niv: numberFormatter.format(cuota_niv),
                // clean_cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,
            }))

        }

    }

    const handleChangeTerm = (event) => {

        const { name, value } = event.target

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState } } = Forms

        const {
            clean_monto_venta,
            clean_monto_enganche,
            clean_gps,
            clean_seguro,
            clean_otros,
            interes,
            tipo_cuota
        } = formState
        const cuota_niv = paymentCalculation(clean_monto_venta, clean_monto_enganche, interes, value)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);
        const cuota_total_libre = parseFloat(clean_monto_venta * (interes / 100)) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);

        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        if (tipo_cuota === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                plazo_anios: (value / 12).toFixed(2),
                cuota_niv: numberFormatter.format(cuota_niv),
                clean_cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total),
                clean_total_cuota: cuota_total,
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                plazo_anios: (value / 12).toFixed(2),
                // cuota_niv: numberFormatter.format(cuota_niv),
                // clean_cuota_niv: cuota_niv,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,
            }))
        }
    }

    const handleChangeGPS = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target

        const clean_value = convertToFloat(value)

        const {
            clean_cuota_niv,
            clean_seguro,
            clean_otros,
            tipo_cuota,
            clean_monto_venta,
            interes
        } = formState

        const cuota_total = (parseFloat(clean_cuota_niv) + parseFloat(clean_value) + parseFloat(clean_otros) + parseFloat(clean_seguro));
        const cuota_total_libre = parseFloat(clean_monto_venta * (interes / 100)) + parseFloat(clean_value) + parseFloat(clean_seguro) + parseFloat(clean_otros);

        if (tipo_cuota === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                total_cuota: numberFormatter.format(cuota_total),
                clean_total_cuota: cuota_total,
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,
            }))
        }
    }

    const handleChangeSeguro = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, onInputChangeForNumber, formState } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target

        const clean_value = convertToFloat(value)

        const {
            clean_cuota_niv,
            clean_gps,
            clean_otros,
            clean_monto_venta,
            tipo_cuota,
            interes
        } = formState

        const cuota_total = parseFloat(clean_cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_value) + parseFloat(clean_otros);
        const cuota_total_libre = parseFloat(clean_monto_venta * (interes / 100)) + parseFloat(clean_gps) + parseFloat(clean_value) + parseFloat(clean_otros);

        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        if (tipo_cuota === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                total_cuota: numberFormatter.format(cuota_total),
                clean_total_cuota: cuota_total,

            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,

            }))
        }
    }

    const handleChangeOtros = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        const {
            clean_cuota_niv,
            clean_gps,
            clean_seguro,
            clean_monto_venta,
            tipo_cuota,
            interes
        } = formState

        const cuota_total = parseFloat(clean_cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_value);
        const cuota_total_libre = parseFloat(clean_monto_venta * (interes / 100)) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_value);

        if (tipo_cuota === 'CUOTA NIVELADA') {
            setFormState(prevState => ({
                ...prevState,
                total_cuota: numberFormatter.format(cuota_total),
                clean_total_cuota: cuota_total,
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                total_cuota: numberFormatter.format(cuota_total_libre),
                clean_total_cuota: cuota_total_libre,
            }))
        }
    }

    const fetchDataQuotation = async (idcotizacion) => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/herr-cotizador-credito/quotation/${idcotizacion}`)
            return response.data.data
        } catch (e) {
            console.log(e)
        }
    }

    const generatePDF = async (idcotizacion) => {

        const quotation = await fetchDataQuotation(idcotizacion)

        const cliente = quotation[0]?.nombre_cliente || 'Cliente desconocido';
        const numeroCotizacion = quotation[0]?.numero_cotizacion || 'Sin número de cotización';
        const fecha = quotation[0]?.fecha || ' ';
        const saldoFinanciar = quotation[0]?.saldo_financiar || 'Sin saldo financiar';
        const tipoCuota = quotation[0]?.tipo_cuota || '';
        const observaciones = quotation[0]?.descripcion || '';

        const doc = new jsPDF();

        let y = 15

        const imgWidth = 50;
        const imgHeight = 30;
        doc.addImage(logo, 'PNG', 150, 26, imgWidth, imgHeight); // (imagen, tipo, x, y, ancho, alto)

        // Membrete
        doc.setFont("helvetica", "bold");
        doc.setFontSize(25);
        doc.text('Cotización de Créditos', 105, y, null, null, "center"); // Texto del membrete
        y += 20;
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(numeroCotizacion, 15, y);
        y += 5;
        doc.text(`Fecha: ${fecha}`, 15, y);
        y += 5;
        doc.text(`Cliente: ${cliente}`, 15, y);
        y += 5;
        doc.text(`Saldo inicial: ${saldoFinanciar}`, 15, y);
        y += 5;
        doc.text(`Tipo de cuota: ${tipoCuota}`, 15, y);
        y += 10;

        let columns;
        let rows;
        // Crear la tabla
        if (tipoCuota === 'CUOTA NIVELADA') {

            columns = ['No. Cuota', 'Amortizacion', 'Intereses', 'Seguro', 'GPS', 'Otros', 'Cuota Niv.', 'Cuota Pagar', 'Saldo'];
            rows = quotation.map(cuota => [
                cuota.no_cuota,
                cuota.amortizacion,
                cuota.intereses,
                // cuota.gastos,
                cuota.seguro,
                cuota.gps,
                cuota.otros,
                cuota.cuota_niv,
                cuota.cuota_pagar,
                cuota.saldo,
            ]);
        } else {
            columns = ['No. Cuota', 'Amortizacion', 'Intereses', 'Seguro', 'GPS', 'Otros', 'Cuota Pagar', 'Saldo'];
            rows = quotation.map(cuota => [
                cuota.no_cuota,
                cuota.amortizacion,
                cuota.intereses,
                // cuota.gastos,
                cuota.seguro,
                cuota.gps,
                cuota.otros,
                // cuota.cuota_niv,
                cuota.cuota_pagar,
                cuota.saldo,
            ]);
        }
            
        // Agregar la tabla al PDF
        const tableResult = doc.autoTable({
            head: [columns],
            body: rows,
            startY: y,
        });

        y = doc.lastAutoTable.finalY + 15;

        doc.setFont("times", "normal");
        doc.setFontSize(12);
        y = justifyText(doc, `Observaciones: ${observaciones}`, 15, y, 190);

        y += 7;

        doc.setFontSize(12);
        doc.setFont("times", "italic");
        doc.text('* Esta cotización es válida por 8 días.', 10, y);

        // Guardar el PDF
        doc.save('cotizacion_creditos.pdf');
    };


    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        handleChangeTypeLoan,
        handleChangeMount,
        handleChangeDownPayment,
        handleChangeTerm,
        onSubmitFormQuotation,
        handleChangeGPS,
        handleChangeSeguro,
        handleChangeOtros,
        handleButtonDisable,
        handleChangeTypeCredit,
        generatePDF,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}